import React from 'react'

const RTMPS = (props) => {
  return (
    <div className='help__rtmps'>
      <h3>Custom Setup</h3>
      <ul>
        <li>
          Fill in the provided <strong>Stream Key</strong> and{' '}
          <strong>Server URL</strong>
        </li>
        <li>Click below to add the stream to the target event below</li>
      </ul>
    </div>
  )
}

export default RTMPS
